import { Divider, Grid, Modal, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../../../assets/css/text.css";
import DocumentUpload from "../../../Generics/UploadDocument";
import EmailField from "../../../Generics/EmailField";
import ModalHelper from "../../../Generics/ModalHelper";

const pt1 = { paddingTop: { xs: 2, md: 0 } };
const pt2 = { paddingTop: { xs: 2, md: 2, lg: 0 } };
const pt3 = { paddingTop: 2 };

const ClienteAmlGiuridico = ({
  languange,
  handleAmlUpdate,
  aml,
  errors,
  caseData,
  saveAml,
  documents,
  refreshDocuments,
  saveAmlData,
}) => {
  const [data, setData] = useState(aml?.company || {});
  const [modalHelperOpen, setModalHelperOpen] = useState(false);
  const [modalRegisterOpen, setModalRegisterOpen] = useState(false);
  const [modalReaOpen, setModalReaOpen] = useState(false);

  const findDocument = (name) =>
    (documents || []).find((d) => {
      const base =
        d.assigned_name?.split(".")[0] ?? d.original_name?.split(".")[0];
      return base === name;
    }) ?? null;

  useEffect(() => {
    if (typeof handleAmlUpdate === "function") {
      handleAmlUpdate({ ...aml, company: data });
    }
  }, [data]);

  const t = (eng, ita) => (languange === "ENG" ? eng : ita);
  const ph = t("Insert", "Inserisci");

  const onChange = (e) =>
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const field = (name) => ({
    name,
    value: data[name] || "",
    error: errors.includes(`company.${name}`),
    onChange,
    fullWidth: true,
    placeholder: ph,
    style: {},
  });

  return (
    <>
      <Grid item xs={11}>
        <Typography className="color-blue-dark title-sezione-step">
          {t("Identification data", "Dati identificativi")}
        </Typography>
      </Grid>

      <Grid
        xs={12}
        columnSpacing={4}
        rowSpacing={0}
        item
        container
        style={{ display: "flex", justifyContent: "center" }}
      >
        <Grid item xs={11} md={6} lg={4}>
          <Typography className="color-blue-dark title-input">
            {t("Name", "Denominazione")}
          </Typography>
          <TextField {...field("name")} variant="outlined" />
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt1}>
          <Typography className="color-blue-dark title-input">
            {t("Tax ID number", "Codice fiscale")}
          </Typography>
          <TextField {...field("tax_code")} variant="outlined" />
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt2}>
          <Typography className="color-blue-dark title-input">
            {t("VAT number", "Partita IVA")}
          </Typography>
          <TextField {...field("vat")} variant="outlined" />
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt3}>
          <Typography className="color-blue-dark title-input">
            {t("Address", "Indirizzo sede")}
          </Typography>
          <TextField {...field("address")} variant="outlined" />
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt3}>
          <Typography className="color-blue-dark title-input">
            {t("ZIP code", "CAP")}
          </Typography>
          <TextField {...field("zip")} variant="outlined" />
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt3}>
          <Typography className="color-blue-dark title-input">
            {t("City", "Città")}
          </Typography>
          <TextField {...field("city")} variant="outlined" />
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt3}>
          <Typography className="color-blue-dark title-input">
            {t("Province", "Provincia")}
          </Typography>
          <TextField {...field("province")} variant="outlined" />
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt3}>
          <Typography className="color-blue-dark title-input">
            {t("Nation", "Nazione")}
          </Typography>
          <TextField {...field("country")} variant="outlined" />
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt3}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography className="color-blue-dark title-input">
              {t("Chamber of Commerce city", "Sede Registro Imprese")}
            </Typography>
            {languange === "ENG" && (
              <div
                className="icon-modal-info-helper"
                style={{
                  marginLeft: "8px",
                  cursor: "pointer",
                  marginTop: "-4px",
                }}
                onClick={() => setModalRegisterOpen(true)}
              />
            )}
          </div>
          <TextField {...field("register")} variant="outlined" />
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt3}>
          <Typography className="color-blue-dark title-input">
            {t("Registration number", "Numero iscrizione Registro Imprese")}
          </Typography>
          <TextField {...field("registration_number")} variant="outlined" />
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt3}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography className="color-blue-dark title-input">
              {t("REA number", "Numero REA")}
            </Typography>
            {languange === "ENG" && (
              <div
                className="icon-modal-info-helper"
                style={{
                  marginLeft: "8px",
                  cursor: "pointer",
                  marginTop: "-3px",
                }}
                onClick={() => setModalReaOpen(true)}
              />
            )}
          </div>
          <TextField {...field("rea")} variant="outlined" />
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt3}>
          <DocumentUpload
            languange={languange}
            label={
              languange === "ENG" ? (
                <span style={{ display: "flex", alignItems: "center" }}>
                  Chamber of Commerce certificate
                  <div
                    className="icon-modal-info-helper"
                    style={{
                      marginLeft: "8px",
                      cursor: "pointer",
                      marginTop: "-3px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setModalHelperOpen(true);
                    }}
                  />
                </span>
              ) : (
                "Visura camerale"
              )
            }
            noGrid
            isIdentityDocument={true}
            documentSide={t("client_company_register", "cliente_camerale")}
            existingDocument={findDocument(
              t("client_company_register", "cliente_camerale"),
            )}
            refreshDocuments={refreshDocuments}
            saveAmlData={saveAmlData}
            hasError={errors.includes("company.camerale.upload")}
          />
        </Grid>

        <Grid xs={11} md={12} item>
          <Divider className="divider" />
        </Grid>

        <Grid xs={11} md={12} item container>
          <Grid item xs={11} className="container-title-sezione-step">
            <Typography className="color-blue-dark title-sezione-step">
              {t(
                "Contact details for electronic correspondence",
                "Recapiti per la corrispondenza elettronica",
              )}
            </Typography>
          </Grid>
        </Grid>

        <Grid item xs={11} md={6} lg={4}>
          <EmailField
            label={t("PEC address", "Indirizzo PEC")}
            name="pec"
            errorKey="company.pec"
            value={data["pec"] || ""}
            onChange={onChange}
            placeholder={ph}
            errors={errors}
          />
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt2}>
          <EmailField
            label={t("E-mail address", "Email")}
            name="email"
            errorKey="company.email"
            value={data["email"] || ""}
            onChange={onChange}
            placeholder={ph}
            errors={errors}
          />
        </Grid>

        <Grid item xs={11} md={6} lg={4} />
      </Grid>

      <Modal open={modalHelperOpen} onClose={() => setModalHelperOpen(false)}>
        <div>
          <ModalHelper
            onClose={() => setModalHelperOpen(false)}
            modalObjectInfo={{
              infoTitle: "Chamber of Commerce certificate",
              description:
                "Examples of documents certifying powers of representation include: a power of attorney for natural persons; a Chamber of Commerce register extract for companies.",
              descriptionBis: "",
            }}
            fullWidth={true}
          />
        </div>
      </Modal>

      <Modal
        open={modalRegisterOpen}
        onClose={() => setModalRegisterOpen(false)}
      >
        <div>
          <ModalHelper
            onClose={() => setModalRegisterOpen(false)}
            modalObjectInfo={{
              infoTitle: "Chamber of Commerce city",
              description:
                "If not applicable, you can indicate the city/region of the equivalent foreign register.",
              descriptionBis: "",
            }}
            fullWidth={true}
          />
        </div>
      </Modal>

      <Modal open={modalReaOpen} onClose={() => setModalReaOpen(false)}>
        <div>
          <ModalHelper
            onClose={() => setModalReaOpen(false)}
            modalObjectInfo={{
              infoTitle: "REA number",
              description:
                "If not applicable, you can indicate other identification number.",
              descriptionBis: "",
            }}
            fullWidth={true}
          />
        </div>
      </Modal>
    </>
  );
};

export default ClienteAmlGiuridico;
